import appManager from '@app/appManager';
import { webphoneAppEvents } from '../constants/events';
import { phoneState } from '../state';
import type { NetworkTestResultPayload } from '../types';

/**
 * Forwards `webphone:network-test-result` to the app event bus so UserStatusModule
 * can restore availability when the test succeeds.
 */
const handleNetworkTestResult = (payload: NetworkTestResultPayload): void => {
  phoneState.networkTestInProgress = false;
  appManager.events.emit(webphoneAppEvents.networkTestResult, payload);
};

export default handleNetworkTestResult;
